import React, { useState } from 'react';
import './ContactSection.css';
import { useTranslation } from 'react-i18next';

const ContactSection = () => {
  const { t, i18n } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(false);
    setError(null);

    try {
      const response = await fetch('https://taamirnajd.com/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error(t('contact.errorMessage'));
      }

      setSubmitted(true);
      setFormData({ name: '', email: '', message: '' });

      setTimeout(() => setSubmitted(false), 4000);
    } catch (err) {
      setError(err.message || t('contact.failedMessage'));
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="Partners-header">
        <h2 className="vision-title">{t('contact.title')}</h2>
        <div className="vision-divider">
          <span className="divider-line"></span>
          <span className="divider-diamond">◆</span>
          <span className="divider-line"></span>
        </div>
      </div>

      <div className="contact-container">
        {/* ✅ صندوق المعلومات */}
        <div className="contact-info-box">
          <div className="contact-info">
            <img src="/assets/icons/email.png" alt={t('contact.emailAlt')} className="icon" />
            <a href="mailto:info@taamirnajd.com"><p>info@taamirnajd.com</p></a>
          </div>
          <div className="contact-info">
            <div className="phone-icons">
              <a href="tel:+966509101166">
                <img src="/assets/icons/phone.png" alt={t('contact.phoneAlt')} className="icon" />
              </a>
              <a href="https://wa.me/966509101166" target="_blank" rel="noopener noreferrer">
                <img src="/assets/icons/whatsapp.png" alt={t('contact.whatsappAlt')} className="icon" />
              </a>
            </div>
            <a href="tel:+966509101166">
              <p style={{ direction: 'ltr', unicodeBidi: 'bidi-override' }}>
                +966 509 101 166
              </p>
            </a>
          </div>
          <div className="contact-info">
            <img src="/assets/icons/location.png" alt={t('contact.locationAlt')} className="icon" />
            <a
              href="https://maps.app.goo.gl/Lxby3GfVPVZtiB7y8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <p>{t('contact.address')}</p>
            </a>
          </div>
        </div>

        {/* ✅ الفورم مع اتجاه حسب اللغة */}
        <form 
          className={`contact-form ${i18n.language === 'en' ? 'ltr' : 'rtl'}`} 
          onSubmit={handleSubmit}
        >
          <label>{t('contact.nameLabel')}</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder={t('contact.namePlaceholder')}
          />

          <label>{t('contact.emailLabel')}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder={t('contact.emailPlaceholder')}
          />

          <label>{t('contact.messageLabel')}</label>
          <textarea
            name="message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            placeholder={t('contact.messagePlaceholder')}
          ></textarea>

          <button type="submit">{t('contact.submitButton')}</button>

          {submitted && <p className="success-message">{t('contact.successMessage')}</p>}
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </section>
  );
};

export default ContactSection;
